import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { Article } from 'functions/src/types/firestore/Game/Article';
import Typography from '@mui/material/Typography';
import { ImageOverlayed } from '../ImageOverlayed';

export type ArticleListItemMobileProps = Omit<Article, 'date' | 'link'> & {
  dateFormatted: string;
};

export function ArticleListItemMobile({
  imgUrl,
  dateFormatted,
  description,
  title,
}: ArticleListItemMobileProps) {
  const theme = useTheme();
  return (
    <Stack
      alignItems="center"
      spacing={2}
      sx={{
        width: '360px',
        height: '516px',
        ...theme.panels[4],
        ...theme.glow.panel,
      }}
    >
      <ImageOverlayed
        src={imgUrl}
        width={177}
        height={119}
        alt="Article image"
        sx={{
          borderRadius: 2,
        }}
      />
      <Typography variant="h5" sx={{ textAlign: 'center' }}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ textTransform: 'capitalize', textAlign: 'center' }}
      >
        {dateFormatted}
      </Typography>
      <Typography
        variant="subtitle2"
        color="text.secondary"
        sx={{
          textAlign: 'center',
          overflow: 'hidden',
          display: '-webkit-box',
          textOverflow: 'ellipsis',
          WebkitLineClamp: 5,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {description}
      </Typography>
    </Stack>
  );
}
